module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "three-background"
  }, [_c('div', {
    ref: "bgRenderer",
    staticClass: "background-renderer"
  }), _vm._v(" "), _c('div', {
    ref: "materialRenderer",
    staticClass: "material-renderer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c7cb3be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/ThreeBackground/ThreeBackground.vue
// module id = 265
// module chunks = 0